// export const BACKEND_URL = "http://3.111.85.42" 
// export const BACKEND_URL = "http://127.0.0.1:5000" 
//export const BACKEND_URL = "http://localhost:5000"
export const BACKEND_URL = "/api"
